import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			aboutPrimaryHeliumEngagementContentSectionInnerCls: string;
		}
	},

	slug: string
}

class Engagement extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('About Primary Helium Engagement Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutPrimaryHeliumEngagementContentSectionInnerCls || '','about_primary_helium_engagement', { animCls: 'animate__zoomIn50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Engagement;